import { usePaginatedQuery } from "@blitzjs/rpc"
import { useMemo, useState } from "react"
import { Box, TablePagination } from "@mui/material"
import { groupBy, Dictionary } from "lodash"
import { formatDate } from "app/date"

import getPaginatedDeployments from "../queries/getPaginatedDeployments"
import { DeploymentGroup } from "./DeploymentGroup"
import { DeploymentInput } from "./DeploymentGroupProps"

const ITEMS_PER_PAGE = 25

export const DeploymentList = () => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(ITEMS_PER_PAGE)

  const [{ deployments, count: rowCount }, { isFetching }] = usePaginatedQuery(
    getPaginatedDeployments,
    {
      orderBy: { createdAt: "desc" },
      skip: rowsPerPage * page,
      take: rowsPerPage,
    }
  )

  const deploymentGroups: Dictionary<DeploymentInput[]> = useMemo(() => {
    return groupBy<DeploymentInput>(deployments as any, (deployment) =>
      formatDate(deployment.createdAt)
    )
  }, [deployments])

  return (
    <Box sx={{ m: 1 }}>
      {Object.entries(deploymentGroups).map(([date, deployments]) => {
        return <DeploymentGroup key={date} date={date} deployments={deployments} />
      })}
      <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={rowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, nextPage) => setPage(nextPage)}
        onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
      />
    </Box>
  )
}
